/**
 * Disables future dates for an `ElDatePicker`.
 *
 * @param date date (from an `ElDatePicker` date option).
 */
export const disabledDate = (date: Date) => {
  return date.getTime() > Date.now()
}
